export default __webpack_public_path__ + "static/media/Sec6OurTeam.59fb7577.svg";